import React from 'react';
import Lottie from 'lottie-react';
import SnowflakeLoader from '../../../assets/animations/Snowflake_Loader.json';
import './LoadingBackdrop.css';

/**
 * LoadingBackdrop Component
 * A full-screen loading overlay with a spinner
 * 
 * @param {boolean} isLoading - Whether to show the loading backdrop
 * @param {string} message - Optional message to display below the spinner
 */

const LoadingBackdrop = ({ isLoading, message = 'Loading...' }) => {
    if (!isLoading) return null;

    return (
        <div className="loading-backdrop">
            <div className="loading-content">
                <Lottie
                    animationData={SnowflakeLoader}
                    loop
                    autoplay
                    className="loading-lottie"
                />
                {/* <div className="loading-spinner"></div> */}
                {/* {message && <p className="loading-message">{message}</p>} */}
            </div>
        </div>
    );
};

export default LoadingBackdrop;